import { EInvoicePaymentType, EInvoiceStatus } from '~/graphql/types'
import { Container } from './styles'
import { CONTRAC_INVOICE, translateContractInvoice } from '~/utils'

type FinancialStatusProps = {
  status: EInvoiceStatus
  paymentType?: EInvoicePaymentType
}
export const FinancialStatus: React.FC<FinancialStatusProps> = ({ status, paymentType }) => {
  return (
    <Container status={status}>
      <span>
        {/* eslint-disable-next-line no-nested-ternary */}
        {status === EInvoiceStatus.paid && paymentType
          ? paymentType === EInvoicePaymentType.external ? 'Pago ext.' : 'Pago int.'
          : translateContractInvoice(status, CONTRAC_INVOICE)
        }
      </span>
    </Container>
  )
}
